import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { MaquinaService } from "src/app/maquinas/services/maquina.service";
import { InformeMaquinaEffects } from "./reporte.effects";
import { maquinaInformeReducer } from "./reporte.reducer";
import { ReportesFeatureKey } from "./reporte.state";

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(ReportesFeatureKey, maquinaInformeReducer),
    EffectsModule.forFeature([InformeMaquinaEffects]),
  ],
  providers: [MaquinaService],
})
export class ReporteStoreModule {}
